module.exports = __webpack_public_path__ + "img/evaldone.1be25463.svg";